import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-media-fullscreen-viewer',
  templateUrl: './media-fullscreen-viewer.component.html',
  styleUrls: ['./media-fullscreen-viewer.component.scss']
})
export class MediaFullscreenViewerComponent {
  @Input() images: any[] = []; // [{ image: '', video: '', thumbImage: '' }]
  @Input() imageIndex = 0;
  @Input() show = false;
  @Output() closeEvent = new EventEmitter<void>();

  get currentMedia() {
    const item = this.images?.[this.imageIndex];
    if (!item) {
      return null;
    }

    if (typeof item === 'string') {
      return {
        image: item
      };
    }
    return this.images[this.imageIndex];
  }

  isVideo(media: any): boolean {
    return !!media.video;
  }

  isImage(media: any): boolean {
    return !!media.image && !media.video;
  }

  next() {
    if (this.imageIndex < this.images.length - 1) this.imageIndex++;
  }

  previous() {
    if (this.imageIndex > 0) this.imageIndex--;
  }

  close() {
    this.closeEvent.emit();
  }
}
